import { jsx as _jsx } from "react/jsx-runtime";
import { View } from 'react-native';
import { SuccessPage } from './components/success-page';
import { FailurePage } from './components/failure-page';
import { getAcknowledgeWidgetStyles } from './AcknowledgementPageStyles';
export var AcknowledgementWidgetComponent = props => {
  var status = props.status;
  var acknowledgementWidgetStyles = getAcknowledgeWidgetStyles(props);
  if (status === 'SUCCESS') {
    return _jsx(View, Object.assign({
      style: acknowledgementWidgetStyles.container
    }, {
      children: _jsx(SuccessPage, Object.assign({}, props))
    }));
  } else {
    return _jsx(View, Object.assign({
      style: acknowledgementWidgetStyles.container
    }, {
      children: _jsx(FailurePage, Object.assign({}, props))
    }));
  }
};
AcknowledgementWidgetComponent.genericRendererKey = 'AirAcknowledgementWidget';